import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { BiContainer } from './BiContainer';
export function withBiContainer(biContainerProps) {
    return (Component)=>{
        const WrappedComponent = (props)=>{
            const biProps = typeof biContainerProps === 'function' ? biContainerProps(props) : biContainerProps;
            return /*#__PURE__*/ _jsx(BiContainer, {
                name: biProps.name,
                data: biProps.data,
                children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
            });
        };
        WrappedComponent.displayName = "withBiContainer(".concat(Component.displayName || Component.name || 'Component', ")");
        return WrappedComponent;
    };
}
